import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { List } from 'antd'
import { TextArea } from './TextArea'
import { Button } from './Button'
import { Icon, IconKey } from './Icon'
import { getFormattedDate } from '../clients/tools'
import { Conversation } from '../models/client/conversations'
import { useConversations } from '../hooks/useConversations'

type Props = {
    conversation: Conversation
}

export const CheckinConversation = (props: Props): JSX.Element => {
    const { conversation } = props
    const [smsMessage, setSmsMessage] = useState('')

    const {
        isSmsLoading,
        messages,
        setMessages,
        initialMessages,
        refreshSms,
        setRefreshSms,
        conversationId,
        setConversationId,
        sendCheckinSms,
    } = useConversations()

    const sendSms = async (message: string): Promise<void> => {
        if (conversation && message) {
            await sendCheckinSms({
                conversationId,
                phoneNumber: conversation.phoneNumber,
                message,
            })
        }
    }

    const onClick = async (): Promise<void> => {
        await sendSms(smsMessage)
        setSmsMessage('')
    }
    useEffect(() => {
        setConversationId(conversation.id)
        if (!isSmsLoading) {
            setMessages(initialMessages)
        }
    }, [conversation.id, initialMessages, isSmsLoading, setConversationId, setMessages])

    return (
        <div className="checkin-sms">
            <ChatContainer>
                <List
                    itemLayout="horizontal"
                    dataSource={messages}
                    renderItem={(item) => (
                        <List.Item
                            className={item.inboundMessageId ? 'user-message' : 'system-message'}
                        >
                            <List.Item.Meta
                                title={`${item.inboundMessageId ? 'Driver' : 'System'}`}
                                description={`${getFormattedDate(item.createdAt)}`}
                            />
                            {item.message}
                        </List.Item>
                    )}
                />
            </ChatContainer>
            <LoadingContainer>
                {isSmsLoading && <StyledLoadingIcon iconKey="Loading" color="danger" size={5} />}
            </LoadingContainer>
            <TextArea
                label="Send Message to Driver"
                onChange={(text) => {
                    setSmsMessage(text)
                }}
                value={smsMessage}
            />
            <StyledButton type="text_danger" size="small" label="SEND" onClick={onClick} />
        </div>
    )
}

const StyledLoadingIcon = styled(Icon)`
    margin: 0 auto;
`
const StyledButton = styled(Button)`
    float: right;
    margin: 5px;
`
const LoadingContainer = styled.div`
    display: flex;
    min-width: 390px;
    min-height: 35px;
    text-align: center;
`
const ChatContainer = styled.div`
    display: flex;
    max-width: 400px;
    padding: 5px;
    max-height: 400px;
    overflow: auto;
    flex-direction: column-reverse;
`
